namespace Matrix.Workflow {

	@Serenity.Decorators.registerClass()
    export class RunBookPickerDialog extends Serenity.TemplatedDialog<RunBookPickerDialogOptions> {
        private permissions: RunBookEditor;
        public step: number;
        private groupingPanel: string;

        constructor(opt: RunBookPickerDialogOptions) {
            super(opt);
            this.groupingPanel = $(".slick-grouping-panel").html();
            this.permissions = new RunBookEditor(this.byId('Dependencies') ,{
                showRevoke: false,
                stepId:opt.stepId
            });
            this.step=opt.stepId
            RunBookService.ListExisting({
                StepId:opt.stepId
            }, response => {
                if (response.Entities != null && response.Entities.length>0)
                    this.permissions.set_value(response.Entities.map(x => (<RunBookItem>{ StepCode: x }))); 
            });
        }
 
        protected getTemplate() {
            return ("<div  id='~_Dependencies'></div>");
        }

        protected onDialogOpen() {
            $("s-RunBookPickerDialog").addClass("dialogButtons");
            super.onDialogOpen();
        }
        protected onDialogClose() {
            $(".slick-grouping-panel").html(this.groupingPanel);      
        }

        protected getDialogOptions(): JQueryUI.DialogOptions {
            let opt = super.getDialogOptions();
            let that = this;
            opt.width = 650;
            opt.buttons = [
                {
                    text: Q.text('Dialogs.OkButton'),
                    click: e => {
                        var dependencies = this.permissions.get_value();
                        dependencies = dependencies.slice(0, -1)
                        this.dialogClose();
                        $("[name='Dependencies']").val(dependencies);
                    }
                }, {
                    text: Q.text('Dialogs.CancelButton'),
                    click: () => this.dialogClose()
                }];

            opt.title = 'Select Dependencies';
            opt.close = function (event, ui) {
                this.remove();
            }
            return opt;
        }
    }

    export interface RunBookPickerDialogOptions {
		stepId?: number;
	}
}